export enum SftpImportListColumns {
  CREATED_DATE = 'Date',
  SCHOOL_GROUP = 'School Group',
  SCHOOL = 'School',
  IMPORT_SUBJECT = 'Subject',
  IMPORT_STATUS = 'Status',
  ACTIONS = 'Actions'
}
